import { Suspense } from "react";

import ErrorBoundary from "common/components/ErrorBoundary";

import LoadingContainer from "client/common/components/loading/LoadingContainer";
import { INITIAL_CLIENT_DATA } from "client/common/utils";
import ErrorContainer from "client/common/components/errors/ErrorContainer";
import TextButton from "client/common/components/buttons/TextButton";

import { IProductLineDetails } from "../types";
import Block from "../blocks/components/Block";

import styles from "../styles/ProductLineContent.module.less";

type ProductLineContentProps = {
  productLine: IProductLineDetails;
};

const { is_staff: isStaff } = INITIAL_CLIENT_DATA;

const ProductLineContent = (props: ProductLineContentProps) => {
  const { productLine } = props;

  if (!productLine.contents.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Suspense fallback={<LoadingContainer />}>
        <div className={styles.blocks}>
          {productLine.contents.map((content) => (
            <ErrorBoundary
              key={content.id}
              shouldReportErrors={false}
              fallback={
                isStaff ? (
                  <ErrorContainer
                    title="Bad content JSON set"
                    description={
                      <>
                        Looks like some bad JSON content was set for {productLine.name}. Fix it by{" "}
                        <TextButton
                          href={`/admin/catalog/productlinecontentblock/${content.id}/change/`}
                          hasUnderline={true}
                        >
                          editing the block here
                        </TextButton>{" "}
                        and then refreshing the page. <br /> <br />
                        This message is only visible to staff users.
                      </>
                    }
                  />
                ) : null
              }
            >
              <Block block={content.block} />
            </ErrorBoundary>
          ))}
        </div>
      </Suspense>
    </div>
  );
};

export default ProductLineContent;
